import React from 'react';
import { BarChart2, RefreshCw, Link } from 'lucide-react';
export const LeadManagement = () => {
  return <section id="analytics" className="py-20 bg-gradient-to-b from-black to-zinc-950 relative overflow-hidden" data-id="element-190">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(255,255,255,0.02)_0,_transparent_70%)]" data-id="element-191"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-192">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-193">
          <div className="md:w-1/2" data-id="element-194">
            <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light mb-6" data-id="element-195">
              Lightweight Management <span className="text-white" data-id="element-196">Portal</span>
            </h2>
            <p className="font-['Space_Grotesk'] text-zinc-300 mb-8 font-light" data-id="element-197">
              All conversations—AI or human—are consolidated into a lightweight
              leads management system, giving you complete visibility and
              control.
            </p>
            <div className="space-y-6" data-id="element-198">
              <div className="flex items-start gap-4" data-id="element-199">
                <BarChart2 size={24} className="text-white mt-1" data-id="element-200" />
                <div data-id="element-201">
                  <h3 className="font-['Playfair_Display'] text-xl mb-2" data-id="element-202">
                    Unified Portal
                  </h3>
                  <p className="font-['Space_Grotesk'] text-zinc-400 font-light" data-id="element-203">
                    A web-based dashboard displays analytics, transcripts, and
                    outcomes in one convenient location.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-204">
                <RefreshCw size={24} className="text-white mt-1" data-id="element-205" />
                <div data-id="element-206">
                  <h3 className="font-['Playfair_Display'] text-xl mb-2" data-id="element-207">
                    AI Training Loop
                  </h3>
                  <p className="font-['Space_Grotesk'] text-zinc-400 font-light" data-id="element-208">
                    Staff can audit transcripts and correct AI responses,
                    directly improving future performance.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-209">
                <Link size={24} className="text-white mt-1" data-id="element-210" />
                <div data-id="element-211">
                  <h3 className="font-['Playfair_Display'] text-xl mb-2" data-id="element-212">
                    Integrations
                  </h3>
                  <p className="font-['Space_Grotesk'] text-zinc-400 font-light" data-id="element-213">
                    The system connects with existing firm platforms, ensuring
                    firms don't have to abandon their current tools.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="md:w-1/2" data-id="element-214">
            <div className="relative" data-id="element-215">
              <div className="absolute inset-0 bg-gradient-to-tr from-zinc-800/30 to-zinc-900/30 rounded-sm backdrop-blur-sm" data-id="element-216"></div>
              <div className="border border-white/20 rounded-sm overflow-hidden relative" data-id="element-217">
                <div className="bg-zinc-900 px-4 py-3 border-b border-white/10 flex items-center" data-id="element-218">
                  <div className="w-3 h-3 rounded-full bg-zinc-700 mr-2" data-id="element-219"></div>
                  <div className="w-3 h-3 rounded-full bg-zinc-700 mr-2" data-id="element-220"></div>
                  <div className="w-3 h-3 rounded-full bg-zinc-700" data-id="element-221"></div>
                  <p className="ml-4 text-zinc-400 text-sm font-['Space_Grotesk']" data-id="element-222">
                    LexSquire Dashboard
                  </p>
                </div>
                <div className="p-6 bg-black/80" data-id="element-223">
                  <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-224">
                    <div className="bg-zinc-900/80 p-4 rounded-sm border border-white/10" data-id="element-225">
                      <p className="text-zinc-400 text-sm mb-1 font-['Space_Grotesk']" data-id="element-226">
                        Total Leads
                      </p>
                      <p className="text-2xl font-['Playfair_Display']" data-id="element-227">
                        1,247
                      </p>
                    </div>
                    <div className="bg-zinc-900/80 p-4 rounded-sm border border-white/10" data-id="element-228">
                      <p className="text-zinc-400 text-sm mb-1 font-['Space_Grotesk']" data-id="element-229">
                        Leads in Last 7 Days
                      </p>
                      <p className="text-2xl font-['Playfair_Display']" data-id="element-230">325</p>
                    </div>
                  </div>
                  <div className="bg-zinc-900/80 p-4 rounded-sm border border-white/10 mb-4" data-id="element-231">
                    <div className="flex justify-between items-center mb-3" data-id="element-232">
                      <p className="text-zinc-300 font-['Space_Grotesk']" data-id="element-233">
                        Recent Conversations
                      </p>
                      <p className="text-zinc-500 text-sm font-['Space_Grotesk']" data-id="element-234">
                        View All
                      </p>
                    </div>
                    <div className="space-y-3" data-id="element-235">
                      <div className="flex justify-between items-center py-2 border-b border-white/5" data-id="element-236">
                        <div data-id="element-237">
                          <p className="text-white font-['Space_Grotesk']" data-id="element-238">
                            John Smith
                          </p>
                          <p className="text-zinc-500 text-sm font-['Space_Grotesk']" data-id="element-239">
                            Personal Injury • 2 min ago
                          </p>
                        </div>
                        <div className="bg-zinc-800 px-2 py-1 rounded-sm text-xs text-zinc-300" data-id="element-240">
                          AI Handled
                        </div>
                      </div>
                      <div className="flex justify-between items-center py-2 border-b border-white/5" data-id="element-241">
                        <div data-id="element-242">
                          <p className="text-white font-['Space_Grotesk']" data-id="element-243">
                            Sarah Johnson
                          </p>
                          <p className="text-zinc-500 text-sm font-['Space_Grotesk']" data-id="element-244">
                            Family Law • 15 min ago
                          </p>
                        </div>
                        <div className="bg-zinc-800 px-2 py-1 rounded-sm text-xs text-zinc-300" data-id="element-245">
                          Human Assisted
                        </div>
                      </div>
                      <div className="flex justify-between items-center py-2" data-id="element-246">
                        <div data-id="element-247">
                          <p className="text-white font-['Space_Grotesk']" data-id="element-248">
                            Robert Davis
                          </p>
                          <p className="text-zinc-500 text-sm font-['Space_Grotesk']" data-id="element-249">
                            Estate Planning • 1 hour ago
                          </p>
                        </div>
                        <div className="bg-zinc-800 px-2 py-1 rounded-sm text-xs text-zinc-300" data-id="element-250">
                          AI Handled
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};